export default __webpack_public_path__ + "media/images/features/ja/oirase-20e39e7def3e8bb3f80b482bf7899625.png";